module.exports = __webpack_public_path__ + "static/img/icon-trash-can.8fbd180.png";